var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconaProfilo30(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icona-profilo-30") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0610801167 29.6983351 0.0610801167 29.6983351 29.7593352 0 29.7593352"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona-profilo-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profilo_riposo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6983351,14.9102076 C29.6983351,23.1111174 23.0501174,29.7593352 14.8492076,29.7593352 C6.64816435,29.7593352 -5.33800452e-05,23.1111174 -5.33800452e-05,14.9102076 C-5.33800452e-05,6.70929785 6.64816435,0.0610801167 14.8492076,0.0610801167 C23.0501174,0.0610801167 29.6983351,6.70929785 29.6983351,14.9102076",
    id: "Fill-1",
    fill: "#4E565A",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15,27.5 C10.8333758,27.5 7.15012139,25.2989646 5,21.9629902 C5.05008574,18.5410064 11.6666667,16.6666667 15,16.6666667 C18.3166947,16.6666667 24.9499143,18.5410064 25,21.9629902 C22.8498786,25.2989646 19.1666242,27.5 15,27.5",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,3.33333333 C17.7667582,3.33333333 20,5.56670679 20,8.33324857 C20,11.0999599 17.7667582,13.3333333 15,13.3333333 C12.2332418,13.3333333 10,11.0999599 10,8.33324857 C10,5.56670679 12.2332418,3.33333333 15,3.33333333",
    id: "Fill-6",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaProfilo30);
export default __webpack_public_path__ + "static/media/icona-profilo-30.aeca4e1c5b29bf0afaf332915d009639.svg";
export { ForwardRef as ReactComponent };